export default {
  home: '首页',
  my_accout: '我的账户',
  account_info: '账户信息',
  bonds: '买卖债务申请',
  otherAccount: '交易账户申请',
  records: '资金记录',
  setting: '设置',
  deposit: '存款',
  subAccount: '子账户申请',
  tradeProduct: '交易结构性产品申请',
  withdrawal: '取款',
  internal_transfer: '内部转账',
  download: '平台下载',
  trade_recordes: '交易记录',
  open_trades: '开放交易',
  close_trades: '关闭交易',
  logout: '退出登录',
  'table-download': '文件下载',
  exchange: '换汇',
  quotes: '实时行情服务申请'
}
